import { render, staticRenderFns } from "./UserLogOut.vue?vue&type=template&id=3143027e&scoped=true&"
import script from "./UserLogOut.vue?vue&type=script&lang=js&"
export * from "./UserLogOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143027e",
  null
  
)

export default component.exports